import {
    defineStore,
} from 'pinia';
import {
    computed,
    reactive, toRefs,
} from 'vue';
import {
    createLanguage,
    DEFAULT_LEVEL_ID, languageLevelById,
} from '../models/Language';
import {
    createAdaptedOption,
} from '../utils/AdaptedOption';

export const DEFAULT_ROW = {
    id: null,
    label: '',
    languageId: null,
    level: {},
};
const DEFAULT_LANGUAGE = { ...DEFAULT_ROW, level: languageLevelById(DEFAULT_LEVEL_ID) };

export const useLanguageStore = defineStore('profile-languages', () => {
    const state = reactive({
        languages: [],
    });

    function update({ value }) {
        state.languages = value.map((language) => {
            const existingLanguage = state.languages.find(({ id }) => id === language.id);
            return { ...DEFAULT_LANGUAGE, ...existingLanguage, ...language };
        });
        return state.languages;
    }

    function updateFromQuery(data) {
        // The default row is merged to make sure all necessary fields are initialized.
        state.languages = data.map(language => ({
            ...DEFAULT_ROW,
            id: language.id,
            label: language.title,
            languageId: language.languageId,
            level: language.skillLevel ? {
                id: language.skillLevel,
                label: language.skillLevelLabel,
            } : {},
        }));
    }

    function updateLevel({ label, levelId }) {
        state.languages.find(skill => skill.label === label).level = languageLevelById(levelId);
    }

    const models = computed(() => state.languages.map(x => createLanguage(x)));
    const count = computed(() => state.languages.length);
    const filled = computed(() => state.languages.length > 0);

    return {
        ...toRefs(state),
        update,
        updateFromQuery,
        updateLevel,
        models,
        count,
        filled,
    };
});

export function labelDefinitionAdapter(language) {
    return language.level.label;
}

export function optionAdapter(language) {
    return createAdaptedOption({
        id: language.id,
        label: language.label,
        value: language,
    });
}

export function autocompleteAdapter(item) {
    return { ...DEFAULT_LANGUAGE, label: item.label, languageId: item.id };
}
